module.exports = __webpack_public_path__ + "img/content7.b0ae0856.png";